import PlanInfo from './PlanInfo';

export default PlanInfo;
